interface ListThumbnailProps {
  src: string;
}

export function ListThumbnail({ src }: ListThumbnailProps) {
  return <img src={src} className="h-[54px] w-[54px] rounded-md" />;
}
